import { toOrdinal } from "@/lib/globalFormatterHelper";

const OrderCellRenderer = (params: any) => {
  const returnValue = toOrdinal(params.value);
  return returnValue;
};

export default OrderCellRenderer;
